
const Testimonials = () => {
  const testimonials = [
    {
      name: "Sarah Chen",
      role: "Product Manager at TechFlow",
      company: "TechFlow",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      quote: "This platform transformed how our team collaborates. The approval workflows saved us hours every week."
    },
    {
      name: "Marcus Rodriguez",
      role: "CEO at StartupLab",
      company: "StartupLab", 
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      quote: "We've tried many workspace tools, but this one actually grows with your team. The pricing is transparent and fair."
    },
    {
      name: "Lisa Park",
      role: "Operations Director at ScaleUp Inc",
      company: "ScaleUp Inc",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      quote: "The analytics add-on gives us insights we never had before. It's like having a data analyst on the team."
    }
  ];

  const logos = [
    { name: "TechFlow", width: "120px" },
    { name: "StartupLab", width: "140px" },
    { name: "ScaleUp Inc", width: "130px" },
    { name: "InnovateCorp", width: "150px" },
    { name: "FutureWorks", width: "125px" }
  ];

  return (
    <div className="bg-white py-16">
      <div className="container mx-auto px-4">
        {/* Customer Logos
        <div className="text-center mb-16">
          <p className="text-gray-600 mb-8">Trusted by innovative teams worldwide</p>
          <div className="flex justify-center items-center space-x-8 opacity-60">
            {logos.map((logo, index) => (
              <div 
                key={index}
                className="h-8 bg-gray-300 rounded"
                style={{ width: logo.width }}
              />
            ))}
          </div>
        </div> */}

        {/* Testimonials */}
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            What Our Customers Say
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300 animate-slide-up"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="flex items-start space-x-4 mb-4">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <div className="font-semibold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{testimonial.quote}"</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
